module.exports = __webpack_public_path__ + "assets/img/d5655d8c18edb10ed2f8006e098eda65.svg";